module.exports = __webpack_public_path__ + "img/t1.8b6a55bd.png";